import Sortable from 'sortablejs/Sortable';
export default class PageController {
  constructor(ProductPagesDataProvider, $state) {
    "ngInject"
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    let
      parentId = $state.params.parentId;
    if (parentId == 'all') {
      parentId = 0;
    }
    this.parentId = parentId;
    this.field = 'parent_id,order_by';
    this.order_type = 'asc';
    this.col = 0;
    this.colTopDown = 0;
    if (parentId != 0) {
      this.pageLimit = '9999';
      let
        el = document.getElementById('items');
      let
        vm = this;
      vm.sortingLog = [];
      let
        sortable = Sortable.create(el, {
          onStart: function (evt) {
            evt.oldIndex;
            console.log('start');
          },
          onEnd: function (evt) {
            let
              oldData = angular.copy(vm.categories);
            let
              i = 0;
            if (evt.oldIndex < evt.newIndex) {
              for (i = evt.oldIndex; i <= evt.newIndex; i++) {
                if (i == evt.newIndex) {
                  vm.categories[i] = oldData[evt.oldIndex];
                }
                else {
                  vm.categories[i] = oldData[i + 1];
                }
              }
            }
            if (evt.oldIndex > evt.newIndex) {
              for (i = evt.oldIndex; i >= evt.newIndex; i--) {
                if (i == evt.newIndex) {
                  vm.categories[i] = oldData[evt.oldIndex];
                }
                else {
                  vm.categories[i] = oldData[i - 1];
                }
              }
            }
            vm.categories.map(function (i) {
              vm.sortingLog.push(i.id);
            });
            ProductPagesDataProvider.updateCategoryOrder(vm.sortingLog).then(function (result) {
              vm.getRecords();
            });
            vm.sortingLog = [];
          }
        });
    }
    this.getRecords();
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getRecords();
  }

  getRecords() {
    let
      vm = this;
    let data = [];
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.parentId = vm.parentId;
    data.field = vm.field;
    data.order_type = vm.order_type;
    vm.ProductPagesDataProvider.getSubCategory(data).then(function (result) {
      vm.categories = result.data;
      vm.categoriesTotal = result.total;
    });
  }

  removeCategory(id) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    let vm = this;
    vm.ProductPagesDataProvider.removeCategory(id).then(function (res) {
      vm.getRecords();
    })
  }

  changeStatus(status, id) {
    let
      vm = this;
    let
      data = {'status': status, 'id': id}
    vm.ProductPagesDataProvider.updateCategory(data).then(function (resp) {
      vm.getRecords();
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/components/subcategory_listing/controller.js
 **/